module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--12.ffae3d8c.png";